<script>
  import FetchController from './FetchController.vue';
  export default {
    extends: FetchController,
    methods: {
      getUsername(id) {
        return this.fetchData(`/users/get-username?id=${id}`, 'GET', null, true)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      updatePassword(id, currentPassword, newPassword) {
        return this.fetchData('/users/update-password', 'PUT', {id, currentPassword, newPassword}, true)
          .then(res => {
            if(res.ok) {
              return
            }
            return res.json()
          })
          .then(data => {
            if(data === undefined) {
              return new Promise((resolve) => {
                resolve({status: 204})
              })
            } else {
              return new Promise((resolve) => {
                resolve(data)
              })
            }
          })
      }
    }
  }
</script>